module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoading) ? _c('section', {
    staticClass: "app-contanier"
  }, [_c('header-bar', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "onLeftAction": _vm.onBackEvent
    }
  }), _vm._v(" "), (_vm.isOver) ? _c('section', {
    staticClass: "over-panel"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("更多精彩，敬请期待~")])]) : _vm._e(), _vm._v(" "), (!_vm.isOver) ? _c('section', {
    staticClass: "content-panel",
    attrs: {
      "id": "contentPanel"
    }
  }, [_c('section', {
    staticClass: "title-container"
  }, [_c('div', {
    staticClass: "success-title"
  }, [_vm._v(_vm._s(_vm.successTitle))]), _vm._v(" "), (_vm.successDes) ? _c('div', {
    staticClass: "success-des"
  }, [_vm._v(_vm._s(_vm.successDes))]) : _vm._e()]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.token && !_vm.isOver) ? _c('footer', {
    staticClass: "footer-container",
    on: {
      "click": function($event) {
        _vm.onStopPropagation($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item vux-1px"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }],
    staticClass: "form-input",
    attrs: {
      "id": "phone",
      "autocomplete": "off",
      "type": "tel",
      "placeholder": "请输入手机号",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-item vux-1px",
    staticStyle: {
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        _vm.onStopPropagation($event)
      }
    }
  }, [_c('div', {
    staticClass: "right-r"
  }, [(!_vm.isSendCode) ? _c('div', {
    staticClass: "plain-btn",
    attrs: {
      "for": "code"
    },
    on: {
      "click": _vm.fetchVerificationCode
    }
  }, [_vm._v("获取验证码")]) : _c('div', {
    staticClass: "plain-btn"
  }, [_vm._v(_vm._s(_vm.seconds) + "s后重试")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verificationCode),
      expression: "verificationCode"
    }],
    ref: "verCode",
    staticClass: "form-input code-input",
    attrs: {
      "id": "code",
      "type": "number",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.verificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verificationCode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.onGet
    }
  }, [_vm._v("领取")])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": require("../../assets/pending.png"),
      "width": "110"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "discount-container"
  }, [_c('img', {
    staticClass: "discount-img",
    attrs: {
      "src": require("../../assets/discount.png"),
      "title": "优惠券"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "discount-img detail",
    attrs: {
      "src": require("../../assets/discount-detail.png"),
      "title": "优惠券使用说明"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("手机号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "code"
    }
  }, [_vm._v("验证码")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce6880e"}!./src/pages/Application/components/ShareSuccess/main.html
// module id = 1441
// module chunks = 7